export var InstagramErrorEnum;
(function (InstagramErrorEnum) {
    InstagramErrorEnum["INSTAGRAM_BUSINESS_ACCOUNT_NOT_FOUND"] = "InstagramBusinessAccountNotFound";
    InstagramErrorEnum["CONNECTED_BOT"] = "ConnectedBot";
    InstagramErrorEnum["DISABLED_ACCESS_INSTAGRAM_MESSAGES"] = "DisabledAccessInstagramMessages";
    InstagramErrorEnum["INSTAGRAM_ACCOUNT_IS_NOT_ELIGIBLE"] = "InstagramAccountIsNotEligible";
    InstagramErrorEnum["IS_INSTAGRAM_LINKED"] = "IsInstagramLinked";
    InstagramErrorEnum["ENABLE_PERMISSION"] = "EnablePermission";
})(InstagramErrorEnum || (InstagramErrorEnum = {}));
